/* eslint-disable import/prefer-default-export */
export const convert3HexTo6Hex = (hex: string): string | null => {
  // Check if the input is a valid 3-digit hexadecimal color code
  const validHex3 = /^#?([0-9A-Fa-f]{3})$/;

  // If not valid 3-digit hex return null
  if (!validHex3.test(hex)) {
    return null;
  }

  // Replicate each digit to form a 6-digit hexadecimal color code
  const hex6 = hex
    .replace('#', '')
    .split('')
    .map((char) => char.repeat(2))
    .join('');

  // Add the '#' symbol back to the 6-digit color code
  return `#${hex6}`;
};

const getContrastRatio = (rgb1: number[], rgb2: number[]) => {
  const luminance = ([r, g, b]: number[]) => {
    const a = [
      r,
      g,
      b,
    ].map((v) => {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  };

  const L1 = luminance(rgb1);
  const L2 = luminance(rgb2);
  return (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05);
};

export const guessTextColor = (bgColor: string | null): string | null => {
  if (!bgColor) {
    return null;
  }

  const hex = bgColor.replace('#', '');

  if (hex.length !== 6) {
    throw new Error('Invalid hex color');
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const bg = [
    r,
    g,
    b,
  ];

  const white = [
    255,
    255,
    255,
  ];
  const black = [
    0,
    0,
    0,
  ];

  const contrastWithWhite = getContrastRatio(bg, white);
  const contrastWithBlack = getContrastRatio(bg, black);

  return contrastWithWhite > contrastWithBlack ? '#FFFFFF' : '#000000';
};
